import '../assets/styles/App.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { getCookie, setCookie } from '../cookie/cookies';
import Loading from '../components/Loading';

import checked from '../assets/images/checked.png';
import unchecked from '../assets/images/unchecked.png';
import Footer from '../components/Footer';

const isMobile = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

function Cart() {
    const [selectedItems, setSelectedItems] = useState([]);
    const [cart, setCart] = useState([]);
    const [loading, setLoading] = useState(false);

    const { naver } = window;

    useEffect(() => {
        let tmpCart = getCookie('cart');
        if (tmpCart === undefined) {
            setCart([]);
        } else {
            setCart(getCookie('cart'));
        }
        naverPayButton();
    }, []);

    useEffect(() => {
        document.getElementById('naverpay-button').innerHTML = '';
        naverPayButton();
    }, [selectedItems, cart]);

    const selectAllItem = (e) => {
        if (cart.length === selectedItems.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems(cart);
        }
    };

    const deleteItems = (e) => {
        const newCart = cart.filter((item) => !selectedItems.includes(item));
        setCookie('cart', newCart);
        setCart(newCart);
        setSelectedItems([]);
    };

    const selectItem = (e, item) => {
        if (selectedItems.includes(item)) {
            const newSelectedItems = selectedItems.filter(
                (selectedItem) => selectedItem !== item
            );
            setSelectedItems(newSelectedItems);
        } else {
            setSelectedItems([...selectedItems, item]);
        }
    };

    const increaseQuantity = (e, index) => {
        // change quantity of the selected cart item
        e.preventDefault();
        let newCart = cart;

        if (newCart[index].quantity >= 1) {
            newCart[index].quantity += 1;
        }

        setCart(newCart);
        setCookie('cart', newCart);
        // refresh page
        window.location.reload();
    };

    const decreaseQuantity = (e, index) => {
        e.preventDefault();
        let newCart = cart;

        if (newCart[index].quantity > 1) {
            newCart[index].quantity -= 1;
        }
        setCart(newCart);
        setCookie('cart', newCart);

        // refresh page
        window.location.reload();
    };

    const returnTotalQuantity = () => {
        let total = 0;
        selectedItems.map((item) => {
            total += item.quantity;
        });
        return total;
    };

    const returnTotalPrice = () => {
        let total = 0;
        selectedItems.map((item) => {
            total += parseInt(item.itemPrice) * parseInt(item.quantity);
        });
        return total;
    };

    const purchase = () => {
        if (selectedItems.length === 0) {
            alert('상품을 선택해주세요.');
        } else {
            // TODO: 로딩 화면 추가
            setLoading(true);
            let url = `${process.env.REACT_APP_API_URL}/getOrderIdFromNaver`;
            let data = {
                items: selectedItems,
                NA_CO: getCookie('NA_CO'),
                backURL: isMobile
                    ? 'https://rd2.randomdiversity.com/cart'
                    : 'https://rd2pc.randomdiversity.com/cart',
            };

            axios
                .post(url, data)
                .then((res) => {
                    setLoading(false);
                    console.log(res.data.queryString);
                    let url = `https://order.pay.naver.com/customer/order.nhn?${res.data.queryString}&ORDER_ID=${res.data.orderId}`;
                    if (isMobile) {
                        window.location.href = url;
                    } else {
                        // open the url in another window
                        window.open(url);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const wishlist = () => {
        if (selectedItems.length === 0) {
            return;
        } else {
            // TODO: 로딩 화면 추가
            setLoading(true);
            let url = `${process.env.REACT_APP_API_URL}/getOrderIdFromNaver`;
            let data = {
                items: selectedItems,
            };

            axios
                .post(url, data)
                .then((res) => {
                    setLoading(false);
                    let url = `https://order.pay.naver.com/customer/order.nhn?${res.data.queryString}&ORDER_ID=${res.data.orderId}`;
                    window.location.href = url;
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const naverPayButton = () => {
        // use ref to apply button

        if (cart.length === 0) {
        } else {
            if (isMobile) {
                const buttonMobile = naver.NaverPayButton.apply({
                    BUTTON_KEY: 'E9B87F48-E8F0-4A20-9D03-2CDCACDE0DB4', // 네이버페이에서 제공받은 “버튼 인증 키” 입력.
                    TYPE: 'MA', // 버튼 모음 종류 설정. 모바일은 MA, MB 2가지만 사용.
                    COLOR: 1, // 버튼 모음의 색 설정.
                    COUNT: 1, // 쇼핑몰 상품상세(COUNT:2 사용), 장바구니(COUNT:1 사용) 페이지.
                    ENABLE: 'N', // 품절 등의 이유로 버튼 모음을 비활성화할 때에는 "N" 입력
                    BUY_BUTTON_HANDLER: purchase, // 구매하기 버튼 이벤트 Handler 함수 등록, 품절인 경우 not_buy_nc 함수 사용
                    //BUY_BUTTON_LINK_URL:“naverpay_order.php", // 링크 주소 (필요한 경우만 사용)
                    WISHLIST_BUTTON_HANDLER: wishlist, // 찜하기 버튼 이벤트 Handler 함수 등록
                    //WISHLIST_BUTTON_LINK_URL:“zzim.php", // 찜하기 팝업 링크 주소 (필요한 경우만 사용)
                    EMBED_ID: 'naverpay-button', // 장바구니 페이지에 삽입할 DIV의 ID
                    '': '',
                });
            } else {
                const buttonPC = naver.NaverPayButton.apply({
                    BUTTON_KEY: 'E9B87F48-E8F0-4A20-9D03-2CDCACDE0DB4', // 네이버페이에서 제공받은 “버튼 인증 키” 입력.
                    TYPE: 'C', // 버튼 모음 종류 설정. 모바일은 MA, MB 2가지만 사용.
                    COLOR: 1, // 버튼 모음의 색 설정.
                    COUNT: 1, // 쇼핑몰 상품상세(COUNT:2 사용), 장바구니(COUNT:1 사용) 페이지.
                    ENABLE: 'N', // 품절 등의 이유로 버튼 모음을 비활성화할 때에는 "N" 입력
                    BUY_BUTTON_HANDLER: purchase, // 구매하기 버튼 이벤트 Handler 함수 등록, 품절인 경우 not_buy_nc 함수 사용
                    //BUY_BUTTON_LINK_URL:“naverpay_order.php", // 링크 주소 (필요한 경우만 사용)
                    WISHLIST_BUTTON_HANDLER: wishlist, // 찜하기 버튼 이벤트 Handler 함수 등록
                    //WISHLIST_BUTTON_LINK_URL:“zzim.php", // 찜하기 팝업 링크 주소 (필요한 경우만 사용)
                    EMBED_ID: 'naverpay-button', // 장바구니 페이지에 삽입할 DIV의 ID
                    '': '',
                });
            }
        }
    };

    return (
        <div className='App'>
            {loading ? <Loading /> : null}
            <Header header={'Cart'} />
            <div className='cart-menu'>
                <div className='select-all'>
                    {cart !== undefined &&
                    cart.length === selectedItems.length ? (
                        <img
                            onClick={(e) => selectAllItem(e)}
                            className='checkbox'
                            src={checked}
                        />
                    ) : (
                        <img
                            onClick={(e) => selectAllItem(e)}
                            className='checkbox'
                            src={unchecked}
                        />
                    )}
                    <span>전체선택</span>
                </div>
                <div onClick={(e) => deleteItems(e)} className='delete-items'>
                    선택삭제
                </div>
            </div>
            <div className='cart-content'>
                {cart !== undefined && cart.length !== 0 ? (
                    cart.map((item, index) => {
                        return (
                            <div className='cart-item' key={index}>
                                {selectedItems.includes(item) ? (
                                    <img
                                        onClick={(e) => selectItem(e, item)}
                                        src={checked}
                                        className='checkbox'
                                    />
                                ) : (
                                    <img
                                        onClick={(e) => selectItem(e, item)}
                                        src={unchecked}
                                        className='checkbox'
                                    />
                                )}
                                <div
                                    style={{
                                        display: 'flex',
                                        width: '100%',
                                        justifyContent: 'space-between',
                                        marginTop: '8px',
                                    }}
                                >
                                    <div>
                                        <div className='cart-item-title'>
                                            {item.name}
                                        </div>
                                        <div className='wave-value-container'>
                                            <div className='wave-container'>
                                                &alpha;
                                                <span className='wave-value'>
                                                    {item.value.split(',')[0]}%
                                                </span>
                                            </div>
                                            <div className='wave-container'>
                                                &beta;
                                                <span className='wave-value'>
                                                    {item.value.split(',')[1]}%
                                                </span>
                                            </div>
                                            <div className='wave-container'>
                                                &theta;
                                                <span className='wave-value'>
                                                    {item.value.split(',')[2]}%
                                                </span>
                                            </div>
                                            <div className='wave-container'>
                                                &gamma;
                                                <span className='wave-value'>
                                                    {item.value.split(',')[3]}%
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='cart-item-image'>
                                        <img
                                            style={{ width: '100%' }}
                                            src={require(`../assets/images/${item.id}.png`)}
                                        />
                                    </div>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    }}
                                >
                                    <div className='cart-item-price'>
                                        ₩{item.itemPrice.slice(0, -3)},
                                        {item.itemPrice.slice(-3)}
                                    </div>
                                    <div className='cart-quantity'>
                                        <div
                                            onClick={(e) =>
                                                decreaseQuantity(e, index)
                                            }
                                            style={{
                                                width: `24px`,
                                            }}
                                            className='cart-quantity-button'
                                        >
                                            -
                                        </div>
                                        <div
                                            style={{
                                                width: `52px`,
                                            }}
                                            className='cart-quantity-value'
                                        >
                                            {item.quantity}
                                        </div>
                                        <div
                                            onClick={(e) =>
                                                increaseQuantity(e, index)
                                            }
                                            style={{
                                                width: `24px`,
                                            }}
                                            className='cart-quantity-button'
                                        >
                                            +
                                        </div>
                                    </div>
                                </div>

                                {index === cart.length - 1 ? null : (
                                    <div className='cart-item-divider'></div>
                                )}
                            </div>
                        );
                    })
                ) : (
                    <div className='empty-cart'>
                        장바구니에 담긴 상품이 없습니다
                    </div>
                )}
            </div>
            <div className='divider'></div>
            <div className='cart-summary'>
                <div className='cart-summary-info'>
                    <div className='cart-summary-header'>주문 상품 수</div>
                    <div>
                        <span className='cart-summary-value'>
                            {returnTotalQuantity()}
                        </span>{' '}
                        <span className='cart-summary-unit'> 개</span>
                    </div>
                </div>
                <div className='cart-summary-info'>
                    <div className='cart-summary-header'>총 주문금액</div>
                    <div>
                        <span className='cart-summary-value'>
                            {returnTotalPrice()}
                        </span>{' '}
                        <span className='cart-summary-unit'> 원</span>
                    </div>
                </div>
                <div className='cart-summary-info'>
                    <div className='cart-summary-header'>배송비</div>
                    <div>
                        <span className='cart-summary-value'>2500</span>{' '}
                        <span className='cart-summary-unit'> 원</span>
                    </div>
                </div>
                <div className='cart-summary-info'>
                    <div className='cart-summary-header'>총 결제금액</div>
                    <div>
                        <span
                            className='cart-summary-value'
                            style={{ color: '#ef0000' }}
                        >
                            {selectedItems.length
                                ? returnTotalPrice() + 2500
                                : 0}
                        </span>{' '}
                        <span className='cart-summary-unit'> 원</span>
                    </div>
                </div>
            </div>
            <div style={{ margin: '0 16px' }}>
                <div id='naverpay-button'></div>
                {/* {selectedItems.length ? (
                    <img
                        className='active-purchase-button'
                        onClick={(e) => purchase(e)}
                        src={naverPay}
                    />
                ) : (
                    <img
                        className='inactive-purchase-button'
                        src={inactiveNaverPay}
                    />
                )} */}
            </div>
            <Footer />
        </div>
    );
}

export default Cart;
